import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { Paths } from '../../shared/paths';
import Communities from './communities/Communities';
import AllCommunities from './communities/all-communities/AllCommunities';
import MyCommunities from './communities/my-communities/MyCommunities';
import NewCommunity from './communities/new-community/NewCommunity';
import Community from './community/Community';
import CommunityRequests from './community/communityRequests/CommunityRequests';
import CommunitySubscribers from './community/communitySubscribers/CommunitySubscribers';

export default function SocialRouter() {
  return (
    <Routes>
      <Route path={Paths.communities.list} element={<Communities />}>
        <Route index element={<AllCommunities />} />
        <Route path={Paths.communities.my} element={<MyCommunities />} />
      </Route>
      <Route path={Paths.communities.new} element={<NewCommunity />} />
      <Route
        path={Paths.communities.communitySubscribers(':communityId')}
        element={<CommunitySubscribers />}
      />
      <Route
        path={Paths.communities.communityEdit(':communityId')}
        element={<NewCommunity />}
      />
      <Route
        path={Paths.communities.communityRequests(':communityId')}
        element={<CommunityRequests />}
      />
      <Route path={'/:communityId'} element={<Community />} />
    </Routes>
  );
}
